import * as React from 'react';

const Tick = ({
  fill = '#fff',
  width = '14',
  height = '11'
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width + 'px'}
    height={height + 'px'}
    viewBox="0 0 14 11">
    <path
      d="M12.293.293a1 1 0 011.497 1.32l-.083.094L5 10.414.293 5.707a1 1 0 011.32-1.497l.094.083L5 7.585 12.293.293z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
);

export default Tick;
